import { useState, useEffect } from 'react';

import * as api from '../api.js';

import { useAuth } from '../AuthContext';

export const useUser = () => {
    const [ user, setUser ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const [ error, setError ] = useState(null);

    const { auth, token } = useAuth();

    useEffect(() => {
        const fetchUser = async () => {
            if (!auth.currentUser) {
                setLoading(false);

                return;
            }
            try {
                const userData = await api.getUser(auth.currentUser.uid, token);

                if (userData && userData.error) {
                    setError(userData.error);
                } else {
                    setUser(userData);
                }
            } catch (err) {
                setError('Failed to fetch user data');
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [ auth.currentUser, token ]);

    return { user, token, loading, error };
};